import React from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    background: '#007ad9',
    marginTop: 10,
    cursor: 'pointer'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const Abertos = ({ valor, className, ...rest }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
      onClick={() => {
        history.push('/app/atendimentos/aberto');
      }}
    >
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography style={{ color: '#f2f4f5' }} gutterBottom variant="h6">
              Atendimentos Abertos
            </Typography>
            <Typography style={{ color: '#f2f4f5' }} variant="h1">
              {valor}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Abertos.propTypes = {
  className: PropTypes.string
};

export default Abertos;
